<ng-template #root>
    <div class="autocomplete aa-scrollbar aa-scrollable-y"
         [style.width.px]="width">
        <ng-container *ngTemplateOutlet="content.tpl"></ng-container>
    </div>
</ng-template>
